import { useState } from "react";
import { BarChart4, FileText, LockOpen } from "lucide-react";

import { Button } from "@workspace/ui/components/button";

import { useEposContext } from "../epos-context";
import { OpenCashDrawerDialog } from "./open-cash-drawer-dialog";

export function SettingsView() {
	const { data } = useEposContext();
	const [isOpenDrawerDialogOpen, setIsOpenDrawerDialogOpen] = useState(false);

	const currentDrawerId = data.currentCashDrawer.id || "DRAWER-01";

	return (
		<>
			<div className="grid grid-cols-2 gap-4 p-4 sm:grid-cols-3">
				<Button
					variant="outline"
					className="flex h-32 flex-col items-center justify-center text-center"
					onClick={() => setIsOpenDrawerDialogOpen(true)}
				>
					<div className="mb-2 flex size-12 items-center justify-center rounded-full bg-primary/10">
						<LockOpen className="size-6" />
					</div>
					<span className="font-medium">Open Drawer</span>
				</Button>
				<Button
					variant="outline"
					className="flex h-32 flex-col items-center justify-center text-center"
					onClick={() => {
						// Open reports in a new window/tab
						window.open("/reports", "_blank");
					}}
				>
					<div className="mb-2 flex size-12 items-center justify-center rounded-full bg-primary/10">
						<BarChart4 className="size-6" />
					</div>
					<span className="font-medium">Reports</span>
				</Button>
				<Button
					variant="outline"
					className="flex h-32 flex-col items-center justify-center text-center"
					onClick={() => {
						// Open order history in a new window/tab
						window.open("/orders", "_blank");
					}}
				>
					<div className="mb-2 flex size-12 items-center justify-center rounded-full bg-primary/10">
						<FileText className="size-6" />
					</div>
					<span className="font-medium">Order History</span>
				</Button>
			</div>

			<OpenCashDrawerDialog
				isOpen={isOpenDrawerDialogOpen}
				onOpenChange={setIsOpenDrawerDialogOpen}
				drawerId={currentDrawerId}
			/>
		</>
	);
}
